import request from '@/utils/request'

// 查询短视频分类列表
export function listCommunityVideoCategory(query) {
  return request({
    url: '/community/admin/category/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询短视频分类分页
export function pageCommunityVideoCategory(query) {
  return request({
    url: '/community/admin/category/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询短视频分类详细
export function getCommunityVideoCategory(data) {
  return request({
    url: '/community/admin/category/detail',
    method: 'get',
    params: data
  })
}

// 新增短视频分类
export function addCommunityVideoCategory(data) {
  return request({
    url: '/community/admin/category/add',
    method: 'post',
    data: data
  })
}

// 修改短视频分类
export function updateCommunityVideoCategory(data) {
  return request({
    url: '/community/admin/category/edit',
    method: 'post',
    data: data
  })
}

// 删除短视频分类
export function delCommunityVideoCategory(data) {
  return request({
    url: '/community/admin/category/delete',
    method: 'post',
    data: data
  })
}
